import React from 'react';
import { ASAMark } from 'shared/images/societies';
import { HUB_SOURCE } from 'shared/panda/agent/ag-ui.constants';
import type { HubSource } from 'shared/panda/agent/ag-ui.constants';
import styles from './hub-org-badge.module.scss';

// Per-source badge (mark + acronym) for an answer from a shared knowledge hub.
// Add a source here as the backend gains it; acronyms are proper names, not translated.
const HUB_ORG_BADGES: Record<HubSource, { mark: string; label: string }> = {
  [HUB_SOURCE.ASA]: { mark: ASAMark, label: 'ASA' },
};

// A <div> (not <span>) so the global `.comprehensive-text span` size override
// doesn't inflate the text.
export function HubOrgBadge({ source }: { source: HubSource }) {
  const badge = HUB_ORG_BADGES[source];
  if (!badge) return null;
  return (
    <div className={styles.badge}>
      <img src={badge.mark} alt="" className={styles.logo} />
      {badge.label}
    </div>
  );
}
